import * as constants from './constants';

export function getSettings() {
  return {
    type: constants.GET_SETTINGS_REQUEST,
    isFetching: true,
  };
}

export function getSettingsError(error) {
  return {
    type: constants.GET_SETTINGS_FAILURE,
    isFetching: false,
    errorMessage: error,
  };
}

export function getSettingsSuccess(data) {
  return {
    type: constants.GET_SETTINGS_SUCCESS,
    isFetching: false,
    errorMessage: null,
    data,
  };
}

export function saveSettings(attributes) {
  return {
    type: constants.SAVE_SETTINGS_REQUEST,
    isFetching: true,
    saveSuccess: false,
    attributes,
  };
}

export function saveSettingsError(error) {
  return {
    type: constants.SAVE_SETTINGS_FAILURE,
    isFetching: false,
    errorMessage: error,
  };
}

export function saveSettingsSuccess(data) {
  return {
    type: constants.SAVE_SETTINGS_SUCCESS,
    isFetching: false,
    errorMessage: null,
    saveSuccess: true,
    data,
  };
}



// WEBPACK FOOTER //
// ./src/containers/Settings/actions.js